(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this._boundOpen = this.openSelector.bind(this);
        this._boundClose = this.closeSelector.bind(this);
        this._boundKeyUp = this.onContainerKeyUp.bind(this);
        this._boundItemClick = this.onItemClick.bind(this);
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        if (!this._initialized || !this.elements) return;
        if (this.elements.button) {
          this.elements.button.removeEventListener('click', this._boundOpen);
          this.elements.button.removeEventListener('focusout', this._boundClose);
        }
        this.removeEventListener('keyup', this._boundKeyUp);
        this.querySelectorAll('a').forEach(item => item.removeEventListener('click', this._boundItemClick));
        this._initialized = false;
      }

      init() {
        if (this._initialized) return;
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('ul'),
        };
        if (!this.elements.input || !this.elements.button || !this.elements.panel) {
          if (!this._initRetry) {
            this._initRetry = true;
            requestAnimationFrame(() => {
              this._initRetry = false;
              this.init();
            });
          }
          return;
        }

        this.elements.button.addEventListener('click', this._boundOpen);
        this.elements.button.addEventListener('focusout', this._boundClose);
        this.addEventListener('keyup', this._boundKeyUp);
        this.querySelectorAll('a').forEach(item => item.addEventListener('click', this._boundItemClick));
        this._initialized = true;
      }

      hidePanel() {
        if (this.elements && this.elements.button && this.elements.panel) {
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
        }
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        if (this.elements && this.elements.button) this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        if (this._submitting) return;
        const form = this.querySelector('form');
        const input = this.elements && this.elements.input;
        if (!form || !input) return;

        const locale = event.currentTarget.dataset.value;
        if (!locale) return;

        this._submitting = true;
        input.value = locale;

        var cacheBuster = document.createElement('input');
        cacheBuster.type = 'hidden';
        cacheBuster.name = '_';
        cacheBuster.value = Date.now().toString();
        form.appendChild(cacheBuster);

        form.submit();
      }

      openSelector() {
        if (!this.elements || !this.elements.button || !this.elements.panel) return;
        this.elements.button.focus();
        const isHidden = this.elements.panel.hasAttribute('hidden');
        if (isHidden) {
          this.elements.panel.removeAttribute('hidden');
          this.elements.button.setAttribute('aria-expanded', 'true');
        } else {
          this.elements.panel.setAttribute('hidden', true);
          this.elements.button.setAttribute('aria-expanded', 'false');
        }
      }

      closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) {
          this.hidePanel();
        }
      }
    }
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isHomeOverlay = this.classList.contains('header-wrapper--home-overlay');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.setAnnouncementOffset();
      this.onResizeHandler = this.setAnnouncementOffset.bind(this);
      window.addEventListener('resize', this.onResizeHandler, false);
      if (this.isHomeOverlay) this.header.classList.add('shopify-section-header-home-overlay');
      this.updateOverlayState();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.onResizeHandler) window.removeEventListener('resize', this.onResizeHandler);
      this.header.classList.remove('shopify-section-header-home-overlay');
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.updateOverlayState(scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isHomeOverlay) {
        if (scrollTop > 0) {
          this.header.classList.add('shopify-section-header-sticky');
        } else if (scrollTop <= 0) {
          requestAnimationFrame(this.reset.bind(this));
        }

        this.header.classList.remove('shopify-section-header-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.updateOverlayState(0);
    }

    updateOverlayState(scrollTop = window.pageYOffset || document.documentElement.scrollTop) {
      if (!this.isHomeOverlay) return;
      this.classList.toggle('is-scrolled', scrollTop > 0);
    }

    setAnnouncementOffset() {
      if (!this.isHomeOverlay) return;
      const announcementSection = document.getElementById('shopify-section-announcement-bar');
      const announcementHeight = announcementSection ? announcementSection.offsetHeight : 0;
      this.header.style.setProperty('--announcement-height', `${announcementHeight}px`);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this._boundOpen = this.openSelector.bind(this);
      this._boundClose = this.closeSelector.bind(this);
      this._boundKeyUp = this.onContainerKeyUp.bind(this);
      this._boundItemClick = this.onItemClick.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      if (!this._initialized || !this.elements) return;
      if (this.elements.button) {
        this.elements.button.removeEventListener('click', this._boundOpen);
        this.elements.button.removeEventListener('focusout', this._boundClose);
      }
      this.removeEventListener('keyup', this._boundKeyUp);
      this.querySelectorAll('a').forEach(item => item.removeEventListener('click', this._boundItemClick));
      this._initialized = false;
    }

    init() {
      if (this._initialized) return;
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      if (!this.elements.input || !this.elements.button || !this.elements.panel) {
        if (!this._initRetry) {
          this._initRetry = true;
          requestAnimationFrame(() => {
            this._initRetry = false;
            this.init();
          });
        }
        return;
      }

      this.elements.button.addEventListener('click', this._boundOpen);
      this.elements.button.addEventListener('focusout', this._boundClose);
      this.addEventListener('keyup', this._boundKeyUp);
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this._boundItemClick));
      this._initialized = true;
    }

    hidePanel() {
      if (this.elements && this.elements.button && this.elements.panel) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      if (this.elements && this.elements.button) this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      if (this._submitting) return;
      const form = this.querySelector('form');
      const input = this.elements && this.elements.input;
      if (!form || !input) return;

      const locale = event.currentTarget.dataset.value;
      if (!locale) return;

      this._submitting = true;
      input.value = locale;

      var cacheBuster = document.createElement('input');
      cacheBuster.type = 'hidden';
      cacheBuster.name = '_';
      cacheBuster.value = Date.now().toString();
      form.appendChild(cacheBuster);

      form.submit();
    }

    openSelector() {
      if (!this.elements || !this.elements.button || !this.elements.panel) return;
      this.elements.button.focus();
      const isHidden = this.elements.panel.hasAttribute('hidden');
      if (isHidden) {
        this.elements.panel.removeAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', 'true');
      } else {
        this.elements.panel.setAttribute('hidden', true);
        this.elements.button.setAttribute('aria-expanded', 'false');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
